// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"e833cf75","213":"80525ee6","239":"0fff671e","453":"8532dc5e","732":"66d163e6","762":"cec43c38"}[chunkId] + ".chunk.js";
};